import {Injectable} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {PlaybackDialogComponent} from '../components/dialogs/playback-dialog/playback-dialog.component';
import {TranslateService} from '@ngx-translate/core';
import {AudioService} from './audio.service';

@Injectable({
  providedIn: 'root'
})
export class PlaybackService {
  private dialogRef: MatDialogRef<PlaybackDialogComponent, any>;

  constructor(public dialog: MatDialog,
              private translate: TranslateService,
              private audioService: AudioService
  ) {
  }

  openPlaybackDialog() {
    this.dialogRef = this.dialog.open(PlaybackDialogComponent, {
      disableClose: false,
      data: {
        title: this.translate.get('dialog.playback'),
        spinner: false,
        isPassivePlayback: false
      }
    });

    this.dialogRef.afterClosed().subscribe(() => {
      this.audioService.pauseAudio();
    });
  }
}
